import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FecalScoringModuleState } from '../../model/fecal-scoring.model';

export const getFecalScoringModuleState =
  createFeatureSelector<FecalScoringModuleState>('fecalScoringModule');

export const getFecalScorings = createSelector(
  getFecalScoringModuleState,
  (state) => state.fecalScorings,
);

export const getSelectedLocations = createSelector(
  getFecalScoringModuleState,
  (state) => state.locations,
);

export const getSelectedFecalScoring = createSelector(
  getFecalScoringModuleState,
  (state) => state.selectedFecalScoring,
);
